























import { Message as MessageInterface } from 'base/store/state.interface'
import * as moment from 'moment'
import Vue, { PropType } from 'vue'
import Message from './Message.vue'

interface RenderedMessage extends MessageInterface {
  showDivider: boolean
  showDateInDivider: boolean
  showAuthorName: boolean
  showDateInMessage: boolean
  hasReplies: boolean
  date: string
  belongsToThread: boolean
  showThreadTopic: boolean
}

export default Vue.extend({
  name: 'MessageList',
  components: {
    Message
  },
  props: {
    parentMessage: {
      type: Object as PropType<MessageInterface | undefined>,
      default: {}
    },
    messages: {
      type: Array as PropType<MessageInterface[]>,
      required: true
    },
    channel: {
      type: Object as PropType<MessageChannel | undefined>,
      default: {}
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    channelIsEditable() {
      return (this.channel && this.channel.self_access) ? this.channel.self_access.editable : false
    },
    renderedMessages() {
      const origMessages = this.messages
      const renderedMessages: RenderedMessage[] = []

      origMessages.forEach((origMessage, index) => {
        // workaround for a rare bug when the localstorage is messed up
        if (!origMessage) {
          return
        }

        const message: RenderedMessage = JSON.parse(JSON.stringify(origMessage))

        if (!message) {
          return
        }

        const previousMessage = this.previousMessage(index) as MessageInterface
        const showDateInDivider = this.shouldShowDateDivider(message, previousMessage)
        const isThreadMessage = message.parent_id > 0
        const siblingIsThreadMessage = previousMessage.parent_id > 0
        const bothSiblingsBelongToThread = isThreadMessage && siblingIsThreadMessage
        const isThreadMode = !!this.parentMessage
        const displayMessageAsEmbeddedThread = !isThreadMode && isThreadMessage

        // Trennlinie anzeigen:
        // 1.) zwischen zwei nachrichten, wenn autor wechselt...
        // 1a) ...aber nicht, wenn beide nachrichten eingebettete thread nachrichten sind...
        // 1b) ...es sei denn wir befinden uns in der thread darstellung
        // 2.) zwischen zwei nachrichten, wenn von normaler zu eingebetteter thread nachricht gewechselt wird...
        // 2a) ...oder wenn von eingebetteter thread nachricht zu normaler nachricht gewechselt wird
        // 3.) zwischen zwei nachrichten, wenn sie eingebettete thread nachrichten sind, aber der thread wechselt
        // 4.) zwischen zwei nachrichten, wenn datum sich geändert hat
        let showDivider =
          (
            // 1                                                 // 1a                           // 1b
            (message.author_id !== previousMessage.author_id) && (!bothSiblingsBelongToThread || isThreadMode)
          ) ||
          (
            // 2                                            // 2a
            (isThreadMessage && !siblingIsThreadMessage) || (!isThreadMessage && siblingIsThreadMessage)
          ) ||
          (
            // 3
            bothSiblingsBelongToThread && (message.parent_id !== previousMessage.parent_id)
          ) ||
          // 4
          showDateInDivider

        message.showDivider = showDivider
        message.showDateInDivider = showDateInDivider
        message.showAuthorName = showDivider
        message.showDateInMessage = this.showDate(message, previousMessage)
        message.hasReplies = message.messages.length > 0
        message.date = this.formatMessageTimestamp(message)
        message.belongsToThread = displayMessageAsEmbeddedThread
        message.showThreadTopic = displayMessageAsEmbeddedThread && showDivider

        renderedMessages.push(message)
      })

      return renderedMessages
    }
  },
  methods: {
    showDate(message: MessageInterface | undefined, previousMessage: MessageInterface | undefined): boolean {
      if (!message) return false
      return !(previousMessage && message.author_id === previousMessage.author_id && Math.abs(message.ts_create - previousMessage.ts_create) < 60 * 2)
    },
    previousMessage(index: number): MessageInterface | any {
      if (index <= 0) return {}
      return this.messages[index - 1]
    },
    shouldShowDateDivider(message: MessageInterface | undefined, previousMessage: MessageInterface | undefined): boolean {
      if (!message || !previousMessage) return false

      // Check if previous message is from same day
      const previousMessageCreationMoment = moment.unix(previousMessage.ts_create)
      const currentMessageCreationMoment = moment.unix(message.ts_create)
      return !previousMessageCreationMoment.isSame(currentMessageCreationMoment, 'day')
    },
    formatMessageTimestamp(message: MessageInterface) {
      const creationMoment = moment.unix(message.ts_create)
      return creationMoment.format('DD.MM.YYYY')
    }
  }
})
